import { Inbox } from "lucide-react";
import React from "react";
import ButtonV2 from "../../../../../components/ui/button/v2";

interface ObservationsByAuthorityEmptyStateProps {
  onAddObservations: () => void;
}

const ObservationsByAuthorityEmptyState: React.FC<ObservationsByAuthorityEmptyStateProps> = ({ onAddObservations }) => {
  return (
    <div className="w-full min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 py-3">
        <div className="flex flex-col items-center gap-4 py-6 px-6 border border-dashed border-[#E5E5E5] rounded-[14px] w-full w-[510px]">
          <div className="w-12 h-12 flex items-center justify-center border border-gray-200 rounded-lg">
            <Inbox className="w-6 h-6 text-[#0A0A0A]" />
          </div>

          <div className="flex flex-col items-center gap-2 text-center">
            <h3 className="font-sans font-semibold text-xl leading-7 tracking-[0%] text-[#0A0A0A] text-center">
              Observations by IO Appointing Authority
            </h3>
            <p className="font-sans font-normal text-sm leading-5 tracking-[0%] text-[#737373] text-center max-w-md">
              As the IO Appointing Authority, add your and committee's observations on investigation findings and
              recommendations
            </p>
          </div>

          <ButtonV2
            variant="primary"
            size="md"
            onClick={onAddObservations}
            className="w-[153px] h-9 rounded-md gap-2 py-2 px-4"
          >
            Add Observations
          </ButtonV2>
        </div>
      </div>
    </div>
  );
};

export default ObservationsByAuthorityEmptyState;
